import styled from 'styled-components';
import mediaQueries from 'constants/mediaQueries';

import { colorGrey200 } from 'constants/colors';

export const Container = styled.div`
  position: relative;
  padding: 0 16px;
  border-bottom: 1px solid rgba(240, 241, 242, 0.2);

  ${mediaQueries.tabletAndLarger} {
    padding: 0 40px;
  }
`;

export const Header = styled.div`
  position: relative;
  padding: 26px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  display: inline;
`;

export const Button = styled.button<{ isOpen: boolean }>`
  background-color: transparent;
  border: none;
  outline: 0;
  color: ${colorGrey200};
  opacity: 0.6;
  cursor: pointer;
  display: flex;

  & > svg {
    text-align: center;
    transition: all 0.3s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? `scaleY(-1)` : `none`)};
  }
`;

const BOTTOM_MARGIN = 25;

export const Content = styled.div<{ isOpen: boolean; height: number }>`
  height: ${({ isOpen, height }) =>
    isOpen ? `${height + BOTTOM_MARGIN}px` : 0};
  overflow: hidden;
  margin-bottom: ${({ isOpen }) => (isOpen ? '25px' : 'iniial')};
  transition: all 0.3s ease-in-out;
`;
